module.exports = __webpack_public_path__ + "a2aaaf12dd605b3112e9e2604330618c.pdf";